<main-layout [selected]="'ORDERS'">
    <content>
        <!-- Orders -->
        <div *ngIf="(((ordersList$ | async)?.length || 0) > 0); else noOrders">
            <div class="orders-container">
                <!-- The list of all oders-->
                <div class="orders-list">

                    <!-- 
                        Each item 
                    -->
                    <ng-container *ngFor="let order of (ordersList$ | async)">
                        <div class="order-href" (click)="onOpenOrder(order)" > 
                            <div class="order-item" 
                                #orderElem
                                [attr.data-order-id]="order.id"      
                                [ngClass]="
                                    {'is-current-selected': order.id === (currentSelectedOrder$ | async)?.id,
                                    'is-action-needed-red': 
                                        (order.status === OrderStatus.PAID)  || 
                                        (order.status === OrderStatus.CREATED && order.deliveryOption === DeliveryOption.PICKUP && order.paymentType === PaymentOption.CASH),
                                    'is-action-needed-orange': order.status === OrderStatus.PREPARING}
                            ">
                                <!-- Image -->
                                <div class="logo-main-container">
                                    <div class="logo-image-container">
                                        <!-- Image -->
                                        <div class="logo-image-default">
                                            <div class="logo-icon-default">
                                                
                                                <img [src]="
                                                    order.status === OrderStatus.PENDING_PAYMENT ? 'apps/restaurant/src/assets/restaurant_order_status_payment_pending.svg' :
                                                    order.status === OrderStatus.PAID || 
                                                        (order.status === OrderStatus.CREATED && order.deliveryOption === DeliveryOption.PICKUP && order.paymentType === PaymentOption.CASH) ? 'apps/restaurant/src/assets/restaurant_order_status_action_needed.svg' :
                                                    order.status === OrderStatus.PREPARING ? 'apps/restaurant/src/assets/restaurant_order_status_preparing.svg' :
                                                    order.status === OrderStatus.READY_FOR_PICKUP ? 'apps/restaurant/src/assets/restaurant_order_status_ready_for_pick.svg' :
                                                    order.status === OrderStatus.IN_DELIVERY ? 'apps/restaurant/src/assets/restaurant_order_status_in_delivery.svg' :
                                                    order.status === OrderStatus.DELIVERED ? 'apps/restaurant/src/assets/restaurant_order_status_delivered.svg' :
                                                    order.status === OrderStatus.CANCELLED || order.status === OrderStatus.DECLINED_BY_RESTAURANT ? 'apps/restaurant/src/assets/restaurant_order_status_cancelled.svg' :
                                                    order.status === OrderStatus.REFUNDED ? 'apps/restaurant/src/assets/restaurant_order_status_refunded.svg' :
                                                    'apps/restaurant/src/assets/add-image-default.svg'"/>                                            
                                            </div>
                                            <!-- mini loading spinner-->
                                            <ng-container *ngIf="
                                                order.status === OrderStatus.PAID ||
                                                (order.status === OrderStatus.CREATED && order.deliveryOption === DeliveryOption.PICKUP && order.paymentType === PaymentOption.CASH)"
                                            >
                                                <div class="spinning-loader-action-needed">
                                                    <fs-loading-spinner [variant]="LOADING_STYLE.TWO_DOTS_RED"></fs-loading-spinner>
                                                </div>    
                                            </ng-container>
                                        </div>
                                    </div>
                                </div>
                            
                                <!-- Content -->
                                <div class="item-text-content">
                                    
                                    <!-- Content bottom -->
                                    <div class="item-content-mid">
                                        <div class="item-restaurant-name">
                                            <ng-container *ngFor="let product of order.items; index as productIndex">
                                                {{ product.productName }}{{ productIndex === (order.items.length - 1)  ? "" : ","  }}
                                            </ng-container>
                                        </div>
                                    
                                        
                                        <div class="flex flex-row items-center">
                                            <!-- Status -->
                                                <ng-container *ngIf="
                                                    order.status === OrderStatus.PAID ||
                                                    (order.status === OrderStatus.CREATED && order.deliveryOption === DeliveryOption.PICKUP && order.paymentType === PaymentOption.CASH)">
                                                    <div class="item-order-status white mr-2">
                                                        {{ "orders_page_action_required" | translate }}
                                                    </div>
                                                </ng-container>

                                                <div class="item-order-status mr-2" 
                                                    [ngClass]="{                                                    
                                                        'orange': 
                                                            order.status === OrderStatus.CREATED || 
                                                            order.status === OrderStatus.PENDING_PAYMENT,
                                                        'light-blue': 
                                                            order.status === OrderStatus.PAID || 
                                                            order.status === OrderStatus.ACCEPTED_BY_RESTAURANT,
                                                        'light-red': 
                                                            order.status === OrderStatus.PAYMENT_FAILED || 
                                                            order.status === OrderStatus.CANCELLED ||
                                                            order.status === OrderStatus.DECLINED_BY_RESTAURANT,
                                                        'yellow': order.status === OrderStatus.PREPARING,
                                                        'light-green': 
                                                            order.status === OrderStatus.IN_DELIVERY || 
                                                            order.status === OrderStatus.OUT_FOR_DELIVERY || 
                                                            order.status === OrderStatus.READY_FOR_PICKUP,
                                                        'green': order.status === OrderStatus.DELIVERED,                                                                                                    
                                                        'violet': order.status === OrderStatus.REFUNDED,
                                                    }">
                                                    {{ order.status.charAt(0).toUpperCase() + order.status.slice(1).toLowerCase() }}
                                                </div>

                                            <!-- Delivery type -->
                                            <div class="item-products mr-2">                                            
                                                {{ order.deliveryOption.charAt(0).toUpperCase() + order.deliveryOption.slice(1).toLowerCase() }}
                                            </div>
                                            <!-- Icon bicycle or hand-->
                                            <span class="item-delivery-type">
                                                <img [src]="'apps/restaurant/src/assets/' + ((order.deliveryOption === DeliveryOption.DELIVERY) ? 'delivery-type-bicycle-selected' : 'delivery-type-pick-up-hand-selected')  + '.svg'"/>
                                            </span>
                                        </div>
                                    </div>
                
                                    <!-- Content bottom -->
                                    <div class="item-content-right">
                                        
                                        <div class="item-order-delivery-date">                                            
                                            <span class="item-date">{{ order.createdDate | date:"dd.MMM, hh:mm"}}</span> 
                                        </div>
                                        <div class="item-order-slug">
                                            #{{ order.slug }}
                                        </div>
                                        <div class="item-price">
                                            {{ (
                                                    (order.totalPriceCents || 0) - 
                                                    ( 
                                                        (order.deliveryOption === DeliveryOption.DELIVERY) 
                                                        && order.deliveryProvider === DeliveryProvider.EXTERNAL_DELIVERY ? 
                                                            (order.totalDeliveryPriceCents || 0) : 0
                                                    )
                                                ) | format_cents: true 
                                            }}
                                        </div>
                                    </div>     
                                    
                                    <!-- Selected arrow -->
                                    <div *ngIf="order.id === (currentSelectedOrder$ | async)?.id" class="order-opened-arrow">
                                        <mat-icon class="opened-arrow-icon">play_arrow</mat-icon>
                                    </div>  
                                </div>     
                                                                                
                            </div>
                        </div>
                    </ng-container>
                </div>


                <!-- 
                    Middle content - right - Order details
                -->
                <div class="order-wrapper">
                    <div class="order-rectangle">

                        <!-- 
                            Header CTA 
                        -->                        
                        <!-- Needs Restaurant Approval-->
                        <ng-container *ngIf="
                            (currentSelectedOrder$ | async)?.status === OrderStatus.PAID ||
                            ((currentSelectedOrder$ | async)?.status === OrderStatus.CREATED && (currentSelectedOrder$ | async)?.deliveryOption === DeliveryOption.PICKUP && (currentSelectedOrder$ | async)?.paymentType === PaymentOption.CASH)
                        ">
                            <div class="header-actions-container action-urgent">                                
                                <div class="header-order-cta">
                                    <div class="header-order-text">
                                        {{ "orders_page_header_order" | translate }}
                                        {{ "#" + (currentSelectedOrder$ | async)?.slug }}
                                    </div>
                                    <div class="header-order-accept">

                                        <!-- Has both own delivery and foodis delivery-->
                                        <ng-container *ngIf="
                                            (restaurantData$ | async)?.hasOwnDelivery && 
                                            (restaurantData$ | async)?.hasFoodisDelivery &&
                                            (currentSelectedOrder$ | async)?.deliveryOption === DeliveryOption.DELIVERY; 
                                            else generalDeliveryAcceptanceButton">
                                            
                                            <!-- Own Delivery -->
                                            <fs-button [text]="'orders_page_header_accept_order_own' | translate"
                                                class="button-container"
                                                [style]="'full-width-large-height'"
                                                [leadingIcon]="'check'"
                                                [type]="'raised-primary'"
                                                (onPress)="pressStateChange('ACCEPTED_BY_RESTAURANT', DeliveryProvider.OWN_DELIVERY)">
                                            </fs-button>

                                            <!-- Foodis Delivery -->
                                            <div class="mt-5">
                                                <fs-button [text]="'orders_page_header_accept_order_external' | translate"
                                                    class="button-container"
                                                    [style]="'full-width-large-height'"
                                                    [leadingIcon]="'check'"
                                                    [type]="'raised-primary'"
                                                    (onPress)="pressStateChange('ACCEPTED_BY_RESTAURANT', DeliveryProvider.EXTERNAL_DELIVERY)">
                                                </fs-button>
                                            </div>                                             
                                        </ng-container>


                                        <!-- General accept-->
                                        <ng-template #generalDeliveryAcceptanceButton>
                                            <fs-button [text]="'orders_page_header_accept_order' | translate"
                                                class="button-container"
                                                [style]="'full-width-large-height'"
                                                [leadingIcon]="'check'"
                                                [type]="'raised-primary'"
                                                (onPress)="pressStateChange('ACCEPTED_BY_RESTAURANT')">
                                            </fs-button>
                                        </ng-template>
                                        
                                    </div>
                                </div>
                                <div class="header-order-decline">
                                    <fs-button [text]="'orders_page_header_decline_order' | translate"
                                            class="button-container"
                                            [style]="'full-width-large-height'"
                                            [leadingIcon]="'close'"
                                            [type]="'raised-primary-warn'"
                                            (onPress)="pressStateChange('DECLINED_BY_RESTAURANT')">
                                    </fs-button>
                                </div>
                            </div>    
                        </ng-container>

                        <!-- Order preparing - set ready-->
                        <ng-container *ngIf="(currentSelectedOrder$ | async)?.status === OrderStatus.PREPARING">
                            <div class="header-actions-container action-medium">                                
                                <div class="header-order-cta-preparing">
                                    <div class="header-order-text">
                                        {{ "orders_page_header_order" | translate }}
                                        {{ "#" + (currentSelectedOrder$ | async)?.slug }}
                                    </div>
                                    <div class="header-order-set-prepared"> 
                                        <fs-button [text]="'orders_page_header_food_ready' | translate"
                                                class="button-container"
                                                [style]="'full-width-large-height'"
                                                [leadingIcon]="'room_service'"
                                                [type]="'raised-primary-accent'"
                                                (onPress)="pressStateChange('READY_FOR_PICKUP')">
                                            </fs-button>                                    
                                    </div>
                                </div>
                            </div>    
                        </ng-container>


                        <!--
                            Content order middle details
                        -->
                        <div class="order-rectangle-inner">    

                            <!-- Middle content -->
                            <div class="left-right-container">
                                <div class="left-text">

                                    <div class="left-text-order-details">
                                        <!-- Title -->
                                        <div class="order-items-title">
                                            <div class="order-items-title-left">
                                                {{ "orders_page_items" | translate }}
                                            </div>
                                            <div class="order-items-title-right">
                                                {{ "orders_page_items_id" | translate }}:
                                                {{ (currentSelectedOrder$ | async)?.slug }}
                                            </div>
                                        </div>
                                        
                                        <!-- Products list-->
                                        <ng-container *ngFor="let product of (currentSelectedOrder$ | async)?.items; index as i">

                                            <div class="order-product-item">
                                                <!-- Product headline -->
                                                <div class="order-product-item-headline">
                                                    <div class="order-product-item-headline-name">
                                                        {{ (product.quantity > 1 ? product.quantity + " x " : "")
                                                            + product.productName }}
                                                    </div>
                                                    <div class="order-product-item-headline-price">  
                                                        <!-- Delivery price with Foodis or own driver Delivery -->
                                                        <ng-container *ngIf=" (currentSelectedOrder$ | async)?.deliveryOption === DeliveryOption.DELIVERY
                                                                                && (restaurantData$ | async)?.hasFoodisDelivery || (restaurantData$ | async)?.hasOwnDelivery">
                                                            <ng-container *ngIf="product.quantity === 1; else productMultipleQuantityDelivery">
                                                                {{  (product.productPriceCents || 0) | format_cents: true }}
                                                            </ng-container>
                                                            <ng-template #productMultipleQuantityDelivery>
                                                                {{ "(" + product.quantity + " x " +
                                                                        (product.productPriceCents || 0 | format_cents: true) + 
                                                                    ") = " + (product.quantity * (product.productPriceCents || 0) | format_cents: true)
                                                                }}
                                                            </ng-template>
                                                        </ng-container>

                                                        <!-- Pick-up price -->
                                                        <ng-container *ngIf=" (currentSelectedOrder$ | async)?.deliveryOption === DeliveryOption.PICKUP">
                                                            <ng-container *ngIf="product.quantity === 1; else productMultipleQuantityPickup">
                                                                {{  (product.productPriceCents || 0) | format_cents: true }}
                                                            </ng-container>
                                                            <ng-template #productMultipleQuantityPickup>
                                                                {{ "(" + product.quantity + " x " +
                                                                        (product.productPriceCents || 0 | format_cents: true) + 
                                                                    ") = " + (product.quantity * (product.productPriceCents || 0) | format_cents: true)
                                                                }}
                                                            </ng-template>
                                                        </ng-container>
                                                    </div>
                                                </div>
                                                <!-- Product addons list-->
                                                <ng-container *ngFor="let addon of product.addons">
                                                    <div class="order-product-addons-list">
                                                        <div class="order-product-addon">
                                                            <div class="order-product-addon-name">
                                                                {{(addon.quantity > 1 ? addon.quantity + " x " : "")                                                    
                                                                    + addon.addonName }}
                                                            </div>
                                                            <div class="order-product-addon-price">
                                                                <ng-container *ngIf="addon.quantity === 1; else addonMultipleQuantity">
                                                                    {{ addon.addonPriceCents === 0 ? "" : "+ "}}
                                                                    {{((addon.addonPriceCents || 0) | format_cents: true) }}
                                                                </ng-container>
                                                                <ng-template #addonMultipleQuantity>
                                                                    {{ addon.addonPriceCents === 0 ? "" : "+ "}}
                                                                    {{ "(" + addon.quantity + " x " +
                                                                            (addon.addonPriceCents || 0 | format_cents: true) + 
                                                                        ") = " + (addon.quantity * (addon.addonPriceCents || 0) | format_cents: true)
                                                                    }}
                                                                </ng-template>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                                <!-- Special instructions -->
                                                <div class="order-product-special-instructions" *ngIf="!!product.specialInstructions">
                                                    {{ "orders_page_order_instructions" | translate }} 
                                                    {{ product.specialInstructions }}
                                                </div>
                                            </div>     
                                        </ng-container>

                                        <!-- If DeliveryProvider has Own Driver of the restaurnt, then we need to extra show the order transport delivery too, as the restaurant receives it -->
                                        <ng-container *ngIf="((currentSelectedOrder$ | async)?.deliveryOption === DeliveryOption.DELIVERY) 
                                                            && (currentSelectedOrder$ | async)?.deliveryProvider === DeliveryProvider.OWN_DELIVERY">

                                            <div class="order-product-item">
                                                <!-- Product headline -->
                                                <div class="order-product-item-headline">
                                                    <div class="order-product-item-headline-name-green">
                                                        <div class="delivery-provider-logo">
                                                            <img [src]="'apps/restaurant/src/assets/delivery-type-bicycle-selected.svg'">
                                                        </div>
                                                        <span>{{ "orders_page_delivery_provider_own_price" | translate }}</span>
                                                        
                                                    </div>
                                                    <div class="order-product-item-headline-price-green">  
                                                        + {{ ((currentSelectedOrder$ | async)?.totalDeliveryPriceCents || 0) | format_cents: true }}
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>                                        
                                        
                                        <!-- Total -->
                                        <div class="order-product-item-headline-total">
                                            <div class="order-product-item-headline-name">
                                                {{ "orders_page_order_total" | translate }}
                                            </div>
                                            <div class="order-product-item-headline-price">  
                                                {{ (
                                                        ((currentSelectedOrder$ | async)?.totalPriceCents || 0) - 
                                                        ( 
                                                            ((currentSelectedOrder$ | async)?.deliveryOption === DeliveryOption.DELIVERY) 
                                                            && (currentSelectedOrder$ | async)?.deliveryProvider === DeliveryProvider.EXTERNAL_DELIVERY ? 
                                                                ((currentSelectedOrder$ | async)?.totalDeliveryPriceCents || 0) : 0
                                                        )
                                                    ) | format_cents: true 
                                                }}
                                            </div>
                                        </div>
                                        
                                
                                        <!-- Button - Change status -->
                                        <div class="change-status-container" 
                                                *ngIf="(currentSelectedOrder$ | async)?.status === OrderStatus.READY_FOR_PICKUP
                                                        || (currentSelectedOrder$ | async)?.status === OrderStatus.OUT_FOR_DELIVERY">
                                            <strong>CHANGE STATUS TO:</strong>
                                            
                                            
                                            <fs-button 
                                                    *ngIf="(currentSelectedOrder$ | async)?.status !== OrderStatus.OUT_FOR_DELIVERY"
                                                    [text]="'OUT_FOR_DELIVERY' | translate"
                                                    class="button-container"
                                                    [type]="'raised-primary'" (onPress)="pressStateChange('OUT_FOR_DELIVERY')">
                                            </fs-button>

                                            <fs-button 
                                                    *ngIf="(currentSelectedOrder$ | async)?.status !== OrderStatus.READY_FOR_PICKUP"
                                                    [text]="'DELIVERED' | translate"
                                                    class="button-container"
                                                    [type]="'raised-primary'" (onPress)="pressStateChange('DELIVERED')">
                                            </fs-button>

                                            <!-- <fs-button [text]="'CANCELLED' | translate"
                                                    class="button-container"
                                                    [type]="'raised-primary'" (onPress)="pressStateChange('CANCELLED')">
                                            </fs-button> -->

                                            <!-- <fs-button [text]="'REFUNDED' | translate"
                                                    class="button-container"
                                                    [type]="'raised-primary'" (onPress)="pressStateChange('REFUNDED')">
                                            </fs-button> -->
                                        </div>
                                    </div>

                                    <!-- 
                                        Payment 
                                    -->
                                    <div class="payment-container">
                                        <div class="orders-item-headline">
                                            {{ "orders_page_payment_header" | translate }}
                                        </div>
                                        <div class="payment-container-box">                                            
                                            <!-- CASH selected, pay at pickup location -->
                                            <ng-container *ngIf="(currentSelectedOrder$ | async)?.paymentType === PaymentOption.CASH">
                                                <div class="payment-option">
                                                    <div class="payment-option-logo">
                                                        <img class="pt-2" [src]="'apps/restaurant/src/assets/checkout-cash-selected.svg'">
                                                    </div>
                                                    <span class="payment-option-text">{{ "orders_page_payment_cash" | translate }}</span>
                                                </div>
                                            </ng-container>
                            
                                            <!-- Already paid online -->
                                            <ng-container *ngIf="(currentSelectedOrder$ | async)?.paymentType === PaymentOption.ONLINE">
                                                <div class="payment-option">
                                                    <div class="payment-option-logo">
                                                        <img [src]="'apps/restaurant/src/assets/checkout-online-selected.svg' ">
                                                    </div>
                                                    <span class="payment-option-text">{{ "orders_page_payment_online" | translate }}</span>
                                                </div>
                                            </ng-container>
                                        </div>
                                    </div>

                                    <!-- (Delivery-only) Provider: Own driver or Foodis Driver-->
                                    <ng-container *ngIf="(currentSelectedOrder$ | async)?.deliveryOption === DeliveryOption.DELIVERY 
                                        && ((currentSelectedOrder$ | async)?.status !== OrderStatus.CREATED &&
                                            (currentSelectedOrder$ | async)?.status !== OrderStatus.PENDING_PAYMENT &&
                                            (currentSelectedOrder$ | async)?.status !== OrderStatus.PAID)">
                                        <div class="payment-container" >
                                            <div class="orders-item-headline">
                                                {{ "orders_page_delivery_provider_header" | translate }}
                                            </div>
                                            <div class="payment-container-box">                                            
                                                <!-- Own delivery selected, restaurant itself does the delivery -->
                                                <ng-container *ngIf="(currentSelectedOrder$ | async)?.deliveryProvider === DeliveryProvider.OWN_DELIVERY">
                                                    <div class="payment-option">
                                                        <div class="payment-option-logo">
                                                            <img [src]="'apps/restaurant/src/assets/delivery-type-bicycle-selected.svg'">
                                                        </div>
                                                        <span class="delivery-provider-text">{{ "orders_page_delivery_provider_own_title" | translate }}</span>
                                                        <span class="delivery-provider-text-secondary">{{ "orders_page_delivery_provider_own_description" | translate }}</span>
                                                    </div>
                                                </ng-container>
                                
                                                <!-- Foodis delivery. Our external driver does the delivery-->
                                                <ng-container *ngIf="(currentSelectedOrder$ | async)?.deliveryProvider === DeliveryProvider.EXTERNAL_DELIVERY">
                                                    <div class="payment-option">
                                                        <div class="payment-option-logo">
                                                            <img [src]="'apps/restaurant/src/assets/delivery-type-bicycle-selected.svg'">
                                                        </div>
                                                        <span class="delivery-provider-text">{{ "orders_page_delivery_provider_external_title" | translate }}</span>
                                                        <span class="delivery-provider-text-secondary">{{ "orders_page_delivery_provider_external_description" | translate }}</span>
                                                    </div>
                                                </ng-container>

                                                <ng-container *ngIf="!(currentSelectedOrder$ | async)?.deliveryProvider">
                                                    <div class="payment-option">
                                                        <span class="delivery-provider-text">Error:</span>
                                                        <span class="delivery-provider-text-secondary">Delivery Provider is not set for this order.</span>
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </ng-container>     
                                </div>
    
                                <div class="right-text">


                                    <!--                                    
                                        Current state with steps - vertical list
                                    -->
                                    <div class="orders-item-headline">
                                        {{ "orders_page_status" | translate }}
                                    </div>
                                    <div class="order-item-steps">
                                                                                
                                        <restaurant-vertical-status-progress [items]="verticalStepsList$ | async">

                                        </restaurant-vertical-status-progress>

                                    </div>


                                    <!-- 
                                        Address - user's delivery address 
                                    -->
                                    <div class="orders-item-headline mt-4">
                                        {{ "orders_page_delivery_type" | translate }}
                                        <span class="orders-item-headline-selected">
                                            {{ ("orders_page_delivery_type_" + (currentSelectedOrder$ | async)?.deliveryOption?.toLowerCase()) | translate }}
                                        </span>
                                    </div>
                                    <div class="address-container">                                        
                                        <ng-container *ngIf="(currentSelectedOrder$ | async)?.userAddress; else noUserAddress">
                                            <div class="fs-address-container">
                                                <fs-delivery-address [inputAddress]="(currentSelectedOrder$ | async)?.userAddress">
                                                </fs-delivery-address>    
                                            </div>                                            
                                            <div class="address-cta-buttons">
                                                <div class="address-cta" (mousedown)="onCopyClick()">
                                                    <img class="address-cta-src" [src]="'apps/restaurant/src/assets/copy.svg'"/>
                                                    {{ "orders_page_address_copy" | translate }}
                                                </div>
                                    
                                                <div class="address-cta"  (mousedown)="onExternalMapsClick()">
                                                    <img class="address-cta-src" [src]="'apps/restaurant/src/assets/external-link-file.svg'"/>
                                                    {{ "orders_page_address_maps" | translate }}
                                                </div>
                                            </div>

                                        </ng-container>
                                        <ng-template #noUserAddress>
                                            <div class="p-4">
                                                Error: Customer address not found for this order.
                                            </div>                                            
                                        </ng-template>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>                
        </div>     
        
        <!-- User has no orders -->
        <ng-template #noOrders>                

            <div *ngIf="(isLoadingOrdersAPI$ | async)" class="loading-orders-spin-container">
                <fs-loading-spinner [variant]="LOADING_STYLE.CIRCLE_GRAY"></fs-loading-spinner>
            </div>

            <div *ngIf="!(isLoadingOrdersAPI$ | async)" class="missing-orders-container">
                <!-- Image -->
                <div class="missing-orders-image">
                    <img [src]="'apps/restaurant/src/assets/no-orders-found.jpg'"/>
                </div>

                <!-- Texts -->
                <div class="missing-orders-text-container">
                    <!-- Title -->
                    <div class="missing-orders-title">
                        <!-- Image (mobile) -->
                        <div class="missing-orders-image-mobile">
                            <img [src]="'apps/restaurant/src/assets/no-orders-found.jpg'"/>
                        </div>
                        <div class="mr-2">{{ "orders_page_no_orders_title" |  translate }}</div>
                        <mat-icon>history</mat-icon>
                    </div>
                    <!-- Body -->
                    <div class="missing-orders-body">
                        {{ "orders_page_no_orders_body" |  translate }}
                    </div>
                    <!-- Button -->
                    <ng-container *ngIf="(isVerified$ | async) === false"> 
                        <div class="missing-orders-button">
                            <!-- Button - Check restaurants -->
                            <fs-button [text]="'orders_page_no_orders_cta_1' | translate"
                                    class="button-container"
                                    [type]="'raised'" [leadingIcon]="'assignment_ind'" (onPress)="onPressVerify()">
                            </fs-button>
                        </div>
                    </ng-container>
                </div>
            </div>
        </ng-template>
    </content>
</main-layout>

